import PropTypes from "prop-types";
import React, { Fragment, useContext, useEffect, useState } from "react";
import HeaderOne from "../wrappers/header/HeaderOne";
import FooterOne from "../wrappers/footer/FooterOne";
import { AuthContext } from "../common/Auth";
import { useThemeSettings } from "./state/useThemeSettings";
import SearchBar from "../common/SearchBar";
import { useThemeSettingsData } from "./state/useThemeSettingsData";

const LayoutOne = ({
  children,
  headerContainerClass,
  headerTop,
  headerPaddingClass,
  headerPositionClass,
  isFooterEnabled,
  relativePosition
}) => {

  const { user, settingData, enableLandingPage, themeSettingsData } = useContext(AuthContext)
  const {
    isPublic, expandSearchBarUnderHeaderMenu, showSearchIcon,
  } = useThemeSettings({ settingData });
  const {
    isLPublic
  } = useThemeSettingsData({ themeSettingsData })

  let IsPublicData = isLPublic !== undefined ? isLPublic : isPublic ?? true

  return (
    <Fragment>
      <HeaderOne
        layout={headerContainerClass}
        top={headerTop}
        headerPaddingClass={headerPaddingClass}
        headerPositionClass={headerPositionClass}
        relativePosition={relativePosition}
        isPublic={IsPublicData}

      />
      {expandSearchBarUnderHeaderMenu && showSearchIcon ? <SearchBar execute={true}/> : '' }
      {children}
      {isFooterEnabled && (user || IsPublicData) && <FooterOne
        backgroundColorClass="bg-gray"
        spaceTopClass="pt-100"
        spaceBottomClass="pb-70"
      />}
    </Fragment>
  );
};

LayoutOne.propTypes = {
  children: PropTypes.any,
  headerContainerClass: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  headerTop: PropTypes.string,
  isFooterEnabled: PropTypes.bool,
};

export default LayoutOne;
